export default "__VITE_ASSET__ML4f9US4__"